/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/e_scooter'
export default icon
